<script>
    import {modeStore as mode, sizeStore as size} from "./gp-context-cloner.js";
    import OptionButtons from './gp-optionbuttons.svelte';
    import {getGPTransFunc} from "./gp-translations";

    let trans = getGPTransFunc("gp-cloner");

    let sizes = [
        {val : "optionBrush1", icon: "fa-circle", title: trans('Small brush')},
        {val : "optionBrush2", icon: "fa-circle", title: trans('Medium brush')},
        {val : "optionBrush3", icon: "fa-circle", title: trans('Big brush')}
    ];
    let modes = [
        {val : "hovering", icon: "fa-crosshairs", title: trans('Set source')},
        {val : "painting", icon: "fa-stamp", title: trans('Clone')}
    ];
</script>

<div class="GPClonerOptionButtons GPSearchButtons">
    <OptionButtons bind:value={$size} values={sizes}/>
    <OptionButtons bind:value={$mode} values={modes}/>
</div>
